import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { PageNames, PageContext } from '../Home/HomeTopMailConfirm';
import { Box, Button, Container, TextField } from '@mui/material';
import { Title } from '../Component/Title';
import { Info } from "../Component/Info"
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { useForm } from 'react-hook-form';
import { ErrorIndicator } from '../Utility/ErrorIndicator';
import { i18nContext } from '../i18n/i18nContext';
import { HeldTimesContext } from '../Root/CompetitionRoot';

/**
 * メールアドレス入力フォームの型
 */
interface FormInputType{
    mailAddress: string,
    mailAddressConfirm: string
}

/**
 * メール登録フォーム
 * 登録するメールアドレスをサーバに送信する
 */
export function KaguMailForm() {

    const [t] = useTranslation();

    const {lng} = useContext(i18nContext);

    const {setPage} = useContext(PageContext);

    const heldTimesOption = useContext(HeldTimesContext);

    const {register, handleSubmit, formState:{errors}, watch} = useForm<FormInputType>();

    const watchMailAddress = watch("mailAddress");

    async function onSubmit(inputData: FormInputType) {

        setPage(PageNames.Processing);

        const PostAddress = `/competition/api/registration/ktr010?mailaddress=${inputData.mailAddress}&language=${lng}`

        await fetch(PostAddress, {method: "POST"})
        .then(res => {
            setPage(res.ok ? PageNames.KaguMailComplete: PageNames.ProcessError);
        })
        .catch(err => {
            console.error(err);
        })
    }

    return(
        <>
            <Box>
                <Title>
                    {t("KaguMailForm.Title", heldTimesOption)}
                </Title>
                <Info>
                    {t("KaguMailForm.Text1")}
                </Info>
            </Box>

            <Container maxWidth="sm">
                <Box mt={1}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <TextField id="mailAddress" label={t("KaguMailForm.MailAddress")} variant="outlined" fullWidth
                            margin="normal"
                            sx={{
                                backgroundColor:"white"
                            }}
                            error={errors.mailAddress ? true : false}
                            helperText={ErrorIndicator(errors.mailAddress)}
                            {...register("mailAddress", {required: true, pattern: /^\S+@\S+$/i})}
                        />
                        
                        <TextField id="mailAddressConfirm" label={t("KaguMailForm.MailAddressConfirm")} variant="outlined" fullWidth
                            autoComplete="off"
                            margin="normal"
                            sx={{
                                backgroundColor:"white"
                            }}
                            error={errors.mailAddressConfirm ? true : false}
                            helperText={ErrorIndicator(errors.mailAddressConfirm)}
                            {...register("mailAddressConfirm", {required: true, pattern: /^\S+@\S+$/i, validate: {matchMailAddress: value => value === watchMailAddress}})}
                        />

                        <Grid2 container spacing={1} mt={1}>
                            <Grid2>
                                <Button variant="contained" type="submit">{t("KaguMailForm.Submit")}</Button>
                            </Grid2>
                            <Grid2>
                                <Button variant="outlined" onClick={() => setPage(PageNames.KaguTop)}>{t("Common.Back")}</Button>
                            </Grid2>
                        </Grid2>
                    </form>
                </Box>
            </Container>          
        </>
    );
}